<template>
  <form method="post" :action="location" ref="loginForm">
    <loader/>
    <input name="accessToken" :value="accessToken" type="hidden"/>
    <input name="refreshToken" :value="refreshToken" type="hidden"/>
    <input v-if="!!loginDestination" name="loginDestination" :value="loginDestination"
           type="hidden"/>
  </form>
</template>

<script>
  import Loader from '../shared/LoginLoader';

  export default {
    props: ['target', 'targetType'],
    components: { Loader },
    computed: {
      loginDestination() {
        if (this.targetType === 'enterprise') {
          return '/enterprise';
        } else {
          return null;
        }
      }
    },
    data() {
      return {
        location: (JSON.parse(localStorage.getItem('servers'))).filter((t) => t.key === this.target)[0].href,
        accessToken: null,
        refreshToken: null
      };
    },
    mounted() {
      this.$auth.refresh()
        .then(() => {
          this.accessToken = localStorage.getItem('accessToken');
          this.refreshToken = localStorage.getItem('refreshToken');
          this.$nextTick(() => this.$refs.loginForm.submit());

        });
    }
  };
</script>

<style scoped>

</style>
